// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__3IMhZ","form":"styles_form__1HSF9"};